import { render, staticRenderFns } from "./StatusDetailList.vue?vue&type=template&id=5e8c203a&scoped=true&"
import script from "./StatusDetailList.vue?vue&type=script&lang=js&"
export * from "./StatusDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8c203a",
  null
  
)

export default component.exports